// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/service_definition.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Oauth2Definition, Oauth2DefinitionJson } from "./oauth2_service_pb";
import { file_mochabugapis_adapt_plugins_v1_oauth2_service } from "./oauth2_service_pb";
import type { TlsDefinition, TlsDefinitionJson } from "./tls_service_pb";
import { file_mochabugapis_adapt_plugins_v1_tls_service } from "./tls_service_pb";
import type { VariableDefinition, VariableDefinitionJson } from "./variable_service_pb";
import { file_mochabugapis_adapt_plugins_v1_variable_service } from "./variable_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/service_definition.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_service_definition: GenFile = /*@__PURE__*/
  fileDesc("CjZtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9zZXJ2aWNlX2RlZmluaXRpb24ucHJvdG8SHW1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxIu4CChFTZXJ2aWNlRGVmaW5pdGlvbhItCgRuYW1lGAEgASgJQh+6SBxyGhABGGQyFF5bXyRhLXpdW18kYS16MC05XSokEhsKBWxhYmVsGAIgASgJQgy6SAnYAQFyBBABGGQSJwoLZGVzY3JpcHRpb24YAyABKAlCDbpICtgBAXIFEAEY+gFIAYgBARJFCgh2YXJpYWJsZRgEIAEoCzIxLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLlZhcmlhYmxlRGVmaW5pdGlvbkgAEjsKA3RscxgFIAEoCzIsLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLlRsc0RlZmluaXRpb25IABJBCgZvYXV0aDIYBiABKAsyLy5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5PYXV0aDJEZWZpbml0aW9uSABCDQoEdHlwZRIFukgCCAFCDgoMX2Rlc2NyaXB0aW9uYgZwcm90bzM", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_oauth2_service, file_mochabugapis_adapt_plugins_v1_tls_service, file_mochabugapis_adapt_plugins_v1_variable_service]);

/**
 * The service definition
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceDefinition
 */
export type ServiceDefinition = Message<"mochabugapis.adapt.plugins.v1.ServiceDefinition"> & {
  /**
   * 'name' is the identifier of the service, referenced in code
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'label' is a human-friendly label shown in the UI
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 'description' is an optional detailed description of the service
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * The actual type of service that the definition is
   *
   * @generated from oneof mochabugapis.adapt.plugins.v1.ServiceDefinition.type
   */
  type: {
    /**
     * Variable service containing arbitrary JSON
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.VariableDefinition variable = 4;
     */
    value: VariableDefinition;
    case: "variable";
  } | {
    /**
     * TLS service
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.TlsDefinition tls = 5;
     */
    value: TlsDefinition;
    case: "tls";
  } | {
    /**
     * An OAuth2 service
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.Oauth2Definition oauth2 = 6;
     */
    value: Oauth2Definition;
    case: "oauth2";
  } | { case: undefined; value?: undefined };
};

/**
 * The service definition
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceDefinition
 */
export type ServiceDefinitionJson = {
  /**
   * 'name' is the identifier of the service, referenced in code
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'label' is a human-friendly label shown in the UI
   *
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * 'description' is an optional detailed description of the service
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * Variable service containing arbitrary JSON
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.VariableDefinition variable = 4;
   */
  variable?: VariableDefinitionJson;

  /**
   * TLS service
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.TlsDefinition tls = 5;
   */
  tls?: TlsDefinitionJson;

  /**
   * An OAuth2 service
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.Oauth2Definition oauth2 = 6;
   */
  oauth2?: Oauth2DefinitionJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.ServiceDefinition.
 * Use `create(ServiceDefinitionSchema)` to create a new message.
 */
export const ServiceDefinitionSchema: GenMessage<ServiceDefinition, {jsonType: ServiceDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_service_definition, 0);

